import React, { useState, useRef } from "react";
import { FaTimes, FaDownload, FaUpload } from "react-icons/fa";
import "./ImportModal.css";

const ImportModal = ({ isOpen, onClose, onFileSelect, onExport }) => {
  const [activeTab, setActiveTab] = useState("import");
  const [importType, setImportType] = useState("dxf");
  const [exportType, setExportType] = useState("dxf");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileSelect(file, importType);
      onClose();
      event.target.value = '';
    }
  };

  const handleExport = () => {
    if (onExport) {
      onExport(exportType);
      onClose();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>
            {activeTab === "import" ? "Importation de fichier" : "Exportation de fichier"}
          </h3>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Navigation par onglets */}
        <div className="modal-tabs">
          <button 
            className={`tab-button ${activeTab === "import" ? "active" : ""}`}
            onClick={() => setActiveTab("import")}
          >
            <FaUpload className="tab-icon" />
            Importer
          </button>
          <button 
            className={`tab-button ${activeTab === "export" ? "active" : ""}`}
            onClick={() => setActiveTab("export")}
          >
            <FaDownload className="tab-icon" />
            Exporter
          </button>
        </div>
        
        <div className="modal-body">
          {activeTab === "import" ? (

            <>
              <div className="import-options">
                <label className="import-option">
                  <input
                    type="radio"
                    value="dxf"
                    checked={importType === "dxf"}
                    onChange={(e) => setImportType(e.target.value)}
                  />
                  <span className="radio-custom"></span>
                  <span className="option-text">Importer un fichier DXF</span>
                </label>
                
                <label className="import-option">
                  <input
                    type="radio"
                    value="kml"
                    checked={importType === "kml"}
                    onChange={(e) => setImportType(e.target.value)}
                  />
                  <span className="radio-custom"></span>
                  <span className="option-text">Importer un fichier KML</span>
                </label>
              </div>


            <input
              type="file"
              accept={importType === "dxf" ? ".dxf" : ".kml,.kmz"}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              ref={fileInputRef}
            />
            <button 
              className="export-button"
              onClick={() => fileInputRef.current.click()}
            >
              <FaUpload className="export-icon" />
              Choisir un fichier {importType.toUpperCase()}
            </button>

            </>
          ) : (

            <>
              <div className="export-options">
                <label className="export-option">
                  <input
                    type="radio"
                    value="dxf"
                    checked={exportType === "dxf"}
                    onChange={(e) => setExportType(e.target.value)}
                  />
                  <span className="radio-custom"></span>
                  <span className="option-text">Exporter en format DXF</span>
                </label>
                <label className="export-option">
                  <input
                    type="radio"
                    value="kml"
                    checked={exportType === "kml"}
                    onChange={(e) => setExportType(e.target.value)}
                  />
                  <span className="radio-custom"></span>
                  <span className="option-text">Exporter en format KML</span>
                </label> 
              </div>

              <div className="export-actions">
                <button 
                  className="export-button"
                  onClick={handleExport}
                >
                  <FaDownload className="export-icon" />
                  Télécharger le fichier {exportType.toUpperCase()}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImportModal;